import { VendorBuyingAgreementsListAdmin } from '../../../components/Vendor';

export function BuyingAgreements() {
  return <VendorBuyingAgreementsListAdmin />;
}
